import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { UPDATE_REALM_DATA, UPDATE_REALM_DATA_ERROR, UPDATE_REALM_DATA_LOADING } from '../actions/realmActions';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TRealmPreviewState } from '../libs/store';

export default function connectedRealmSearchReducer(
  state: Partial<TRealmPreviewState> = {},
  action: TAction<any>
): Partial<TRealmPreviewState> {
  switch (action.type) {
    case UPDATE_REALM_DATA: {
      return {
        ...state,
        ...action.payload,
        isLoading: false
      };
    }
    case UPDATE_REALM_DATA_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case UPDATE_REALM_DATA_ERROR: {
      return {
        ...state,
        error: action.payload,
        isError: true,
        isLoading: false
      };
    }
    case LOCATION_CHANGE: {
      return {};
    }
    default:
      return state;
  }
}
